import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CarType } from "types/loadedData";

interface CarState {
  car: CarType | null;
  cars: CarType[];
  liveCars: CarType[];
}

const initialState: CarState = {
  car: null,
  cars: [],
  liveCars: [],
};

export const car = createSlice({
  name: "car",
  initialState,
  reducers: {
    setCar: (state, action: PayloadAction<CarType | null>) => {
      state.car = action.payload;
    },
    setCars: (state, action: PayloadAction<CarType[]>) => {
      state.cars = action.payload;
    },
    setLiveCars: (state, action: PayloadAction<CarType[]>) => {
      state.liveCars = action.payload;
    },
  },
});

export const { setCar, setCars, setLiveCars } = car.actions;

export default car.reducer;
